var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{class:[
    _vm.$options.name,
    'ff-sueca-bold',
    ( _obj = {}, _obj[("" + _vm.styleClass)] = _vm.styleClass, _obj )]},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }